export const MediaContentType = {
    IMAGE: "MediaContentType.IMAGE",
    VIDEO: "MediaContentType.VIDEO",
    PDF: "MediaContentType.PDF",
    IMAGEORPDF: "MediaContentType.IMAGEORPDF",
    ALL: "All"
};